// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"368":"e557cb93","407":"df0a2b4e"}[chunkId] + ".chunk.css";
};